import { Spinner } from "@fluentui/react"
import { dateAndTime, EnvelopeKind, StatusData } from "@oneethos/shared"
import { useState } from "react"
import { FaExternalLinkAlt } from "react-icons/fa"
import { useAppState } from "../hooks"
import api from "../api-client"
import { toast } from "react-toastify"
import { errorToString } from "@oneethos/shared"
import { Link } from "./link"

const EnvelopeStatus = ({ status }: { status: string }) => {
  switch (status) {
    case 'voided':
      return <span className="text-secondary fst-italic">voided</span>
    case 'customer-signed':
      return <span className="text-success">signed</span>
    default:
      return <span>{status || '(unknown status)'}</span>
  }
}

const EnvelopeLink = ({ envelope, tenant }) => {
  const { status } = envelope

  return <div className="mb-2">
    <Link
      href={`${tenant.config.docusign?.appUrl}/send/documents/details/${envelope.envelopeId}`}
      target="_blank"
      variant={status === 'voided' ? 'secondary' : 'primary'}
    >
      {dateAndTime(new Date(envelope.timestamp))}
      <FaExternalLinkAlt className="ms-2" />
    </Link>
    <div className="small">{envelope.kind === EnvelopeKind.LoanModification ? 'Loan Modification' : 'Loan Docs'}</div>
    <div className="small"><EnvelopeStatus status={status} /></div>
  </div>
}

type DocusignEnvelopesProps = {
  project: StatusData
  onChange: (project: StatusData) => void
}

export const DocusignEnvelopes = ({ project, onChange }: DocusignEnvelopesProps) => {
  const { tenant } = useAppState()
  const [drafting, setDrafting] = useState(false)

  return <div className="docusign-envelopes">
    <h6>Docusign Envelopes</h6>
    {project.envelopes?.length
      ? project.envelopes?.map((e, i) => <EnvelopeLink key={i} envelope={e} tenant={tenant} />)
      : <div className="alert alert-secondary text-small py-2">no envelopes found</div>
    }

    {project.productId ? (
      drafting ? <Spinner /> : <button type="button"
        className="btn btn-primary btn-sm mt-2"
        onClick={ev => {
          ev.preventDefault()
          const dt = project.updatedDate?.toLocaleString()
          if (!window.confirm(`To prevent errors, please make sure this project has synced the latest changes from Airtable before proceeding. This record was last updated at ${dt}.\n\nContinue to draft loan docs?`)) {
            return Promise.resolve()
          }

          setDrafting(true)
          return api.post(`/loanapps/${project.id}/envelopes`)
            .then(res => {
              toast.success('Draft Loan Docs Created!')
              onChange(new StatusData(res))
            })
            .catch(ex => { toast.error(errorToString(ex)) })
            .finally(() => setDrafting(false))
        }}
      >
        Draft New Loan Docs
      </button>
    ) : <div className="alert alert-light text-small">Not eligible for new loan docs</div>}

    {/* TODO: probably show these in a modal when clicking "Draft New Loan Docs" <PaymentDetails project={project} /> */}
  </div>

}